module.exports = __webpack_public_path__ + "static/media/notice.f30f0e71.mp3";